import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const DefaultPaneSize = Schema.Struct({ firstPaneSize: Schema.Number, vertical: Schema.Boolean, min: Schema.Number, max: Schema.Number });
export type DefaultPaneSize = typeof DefaultPaneSize.Type;
export class DefaultPaneSizeFailure extends privateDependencyFailure<DefaultPaneSizeFailure>()("DefaultPaneSizeFailure", "default pane size") {}
export const defaultPaneSizeFailure = (cause: unknown) => new DefaultPaneSizeFailure({ cause: Redacted.make(cause) });
